import React from "react"
import { css } from "styled-components"
import VariantContainer, {
  IStyleVariant,
} from "../../design-system/atoms/variant-container"
import mergeVariants from "../../design-system/util/merge-variants"

interface ICarouselArrow {
  className: string
  onClick: React.MouseEventHandler<HTMLDivElement>
  imageURL: string
  arrowVariants?: IStyleVariant | any[]
}

const CarouselArrow = ({
  className,
  onClick,
  imageURL,
  arrowVariants,
}: ICarouselArrow) => {
  return (
    <VariantContainer
      variants={mergeVariants(
        [
          css`
            .slick-next,
            .slick-prev {
              ::before {
                content: "";
              }
              img {
                width: 2vw;
                max-width: 25.66px;
              }
              top: 37%;
              opacity: 0.25;
            }
            .slick-next {
              right: -60px;
            }
            .slick-prev {
              left: -67px;
              z-index: 1;
            }
          `,
        ],
        arrowVariants
      )}
    >
      <div className={className} onClick={onClick}>
        <img src={imageURL} />
      </div>
    </VariantContainer>
  )
}

export default CarouselArrow
